export enum AutomatedTransferColumnKeys {
  EQUIPMENT_NAME = 'equipmentName',
  EQUIPMENT_MODEL = 'equipmentModel',
  TRANSFER_STATUS = 'equipmentTransferStatus',
  SOURCE_LOCATION_NAME = 'sourceLocationName',
  SOURCE_LOCATION_TYPE = 'sourceLocationType',
  TARGET_LOCATION_NAME = 'targetLocationName',
  TARGET_LOCATION_TYPE = 'targetLocationType',
  DURATION_SINCE_LEAVING_SOURCE_LOCATION = 'durationSinceLeavingSourceLocation',
  TIMESTAMP_SOURCE_GEOFENCE_LEFT = 'timestampSourceLocationGeofenceLeft',
  TIMESTAMP_TARGET_LOCATION_GEOFENCE_ENTERED = 'timestampTargetLocationGeofenceEntered',
  DURATION_UNTIL_NOTIFICATION = 'durationUntilNotificationIsSent',
  CURRENT_GPS_LOCATION = 'currentGeolocation',
  CURRENT_ADDRESS = 'currentAddress',
  ACTIONS = 'actions',
  REMAINING_TRANSFER_TRIGGER_THRESHOLD = 'remainingTransferTriggerThreshold',
}
